import React, { useState } from "react";
import styled from "styled-components";
import DefaultModalLayout from "../../../Modal/DefaultModalLayout";

const PURCHASE_OPTIONS = ["G2A", "Eneba", "SEAGM", "driffle", "기타"] as const;

interface GPTSoloCommentInputModalProps {
  closeEvent: () => void;
  confirmEvent: (content: string) => void;
}

export default function GPTSoloCommentInputModal({
  closeEvent,
  confirmEvent,
}: GPTSoloCommentInputModalProps) {
  const [purchaseType, setPurchaseType] = useState("");
  const [customPurchaseType, setCustomPurchaseType] = useState("");
  const [orderNumber, setOrderNumber] = useState("");
  const [keyValue, setKeyValue] = useState("");
  const [registrationSite, setRegistrationSite] = useState("");

  const purchaseInfo =
    purchaseType === "기타" ? customPurchaseType : purchaseType;

  const isConfirmDisabled = purchaseInfo.trim() === "";

  const handleConfirm = () => {
    const content =
      `1. 구매정보: ${purchaseInfo}\n` +
      `2. 주문번호: ${orderNumber}\n` +
      `3. Key: ${keyValue}\n` +
      `4. 등록사이트: ${registrationSite}`;
    confirmEvent(content);
  };

  return (
    <DefaultModalLayout
      modalTitle="코멘트 정보 입력"
      closeEvent={closeEvent}
      confirmEvent={handleConfirm}
      confirmDisabled={isConfirmDisabled}
      confirmBtnText="등록"
      type="input"
      isSmallModal={false}
    //   isMediumModal={true}
    isLargeModal={true}
    >
      <FormWrapper>
        <FormRow>
          <Label>구매정보</Label>
          <SelectWrapper>
            <StyledSelect
              value={purchaseType}
              onChange={(e) => {
                setPurchaseType(e.target.value);
                if (e.target.value !== "기타") {
                  setCustomPurchaseType("");
                }
              }}
            >
              <option value="" disabled>
                선택하세요
              </option>
              {PURCHASE_OPTIONS.map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </StyledSelect>
            {purchaseType === "기타" && (
              <StyledInput
                placeholder="구매정보를 입력하세요"
                value={customPurchaseType}
                onChange={(e) => setCustomPurchaseType(e.target.value)}
              />
            )}
          </SelectWrapper>
        </FormRow>

        <FormRow>
          <Label>주문번호</Label>
          <StyledInput
            placeholder="주문번호를 입력하세요"
            value={orderNumber}
            onChange={(e) => setOrderNumber(e.target.value)}
          />
        </FormRow>

        <FormRow>
          <Label>Key</Label>
          <StyledInput
            placeholder="Key를 입력하세요"
            value={keyValue}
            onChange={(e) => setKeyValue(e.target.value)}
          />
        </FormRow>

        <FormRow>
          <Label>등록 사이트</Label>
          <StyledInput
            placeholder="등록 사이트를 입력하세요"
            value={registrationSite}
            onChange={(e) => setRegistrationSite(e.target.value)}
          />
        </FormRow>
      </FormWrapper>
    </DefaultModalLayout>
  );
}

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const FormRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #333;
`;

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StyledSelect = styled.select`
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
  background-color: #fff;
  outline: none;

  &:focus {
    border-color: #42c6b5;
  }
`;

const StyledInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: #42c6b5;
  }

  &::placeholder {
    color: #aaa;
  }
`;
